import { Check } from "lucide-react";

const SIGNALS = [
  { label: "UNDRIP-aligned", title: "Aligned with the UN Declaration on the Rights of Indigenous Peoples" },
  { label: "FPIC-compliant", title: "Free, Prior and Informed Consent workflows by design" },
  { label: "ICIP-respecting", title: "Indigenous Cultural and Intellectual Property held by community" },
  { label: "Sovereign hosting", title: "Australian-hosted infrastructure with controlled access" },
  { label: "Aboriginal-owned", title: "Aboriginal-owned, Aboriginal-led, Aboriginal-governed" },
];

export default function TrustBar() {
  return (
    <section
      className="border-b border-stone-200 bg-stone-50"
      data-testid="trust-bar"
      aria-label="Compliance and authority signals"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-6">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-3 md:gap-x-5">
          <div className="text-[10px] tracking-[0.28em] uppercase font-bold text-stone-500 shrink-0 mr-2">
            Built to
          </div>
          {SIGNALS.map((s) => (
            <div
              key={s.label}
              title={s.title}
              data-testid={`trust-signal-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="inline-flex items-center gap-2 border border-stone-300 bg-[#FAFAF9] px-3 py-1.5 text-[11px] font-semibold tracking-wide text-stone-800 hover:border-[#9C4221]/60 hover:text-[#9C4221] transition-colors cursor-help"
            >
              <Check className="h-3 w-3 text-[#9C4221]" strokeWidth={3} />
              {s.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
